/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import LiveCardSkeleton from '@dtvgo/live-card-skeleton';

/* Components */
import SwimlaneSkeleton from '../SwimlaneSkeleton';

/* Styles */
import './SwimlaneLiveSkeleton.scss';

const NUMBER_OF_CARDS = 5;

function SwimlaneLiveSkeleton({ withTitle }) {
  return (
    <SwimlaneSkeleton withTitle={withTitle}>
      {Array.from({ length: NUMBER_OF_CARDS }).fill().map((value, index) => (
        <LiveCardSkeleton
          // eslint-disable-next-line react/no-array-index-key -- only presentational
          key={index}
          className="dtv-html5-c-swimlane-live-skeleton__card"
        />
      ))}
    </SwimlaneSkeleton>
  );
}

SwimlaneLiveSkeleton.propTypes = {
  withTitle: PropTypes.bool,
};

SwimlaneLiveSkeleton.defaultProps = {
  withTitle: true,
};

export default memo(SwimlaneLiveSkeleton);
